import { render, staticRenderFns } from "./simples_nacional.vue?vue&type=template&id=69e733d0&scoped=true&"
import script from "./simples_nacional.vue?vue&type=script&lang=js&"
export * from "./simples_nacional.vue?vue&type=script&lang=js&"
import style0 from "./simples_nacional.vue?vue&type=style&index=0&id=69e733d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e733d0",
  null
  
)

export default component.exports